import {Link}from 'react-router-dom';
import "../Energie-renv/Energie.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import 'bootstrap/dist/css/bootstrap.min.css'
import AOS from 'aos';



import Pumping from '../../image/Pumping.jpg'
import PhotoPlant from '../../image/PhotoPlant.jpg'
import offgridsolar from '../../image/offgridsolar.jpg'

import ongirdsystem from '../../image/ongirdsystem.jpg'
import IndividualSolar from '../../image/IndividualSolar.jfif'
import Biogaz from '../../image/Biogaz.jpg'
import EnergyStorage from '../../image/EnergyStorage.jpg'
import WIND from '../../image/WIND.jpg'
import audit from '../../image/audit.png'
import GTB from '../../image/GTB.jpg'
import mesure from '../../image/mesure.jpg'
import iso from '../../image/iso.jpg'


import Model from '../../component/ModelButton/Model';

function EnergieRenv (){
    AOS.init();
    return(
     <div id="#">
         <div className=" container-fluid bg-secondary pt-2 pt-lg-5 pb-2 mb-5">
            <div className="container py-5">
                <div className="row row-box align-items-center py-4">
                    <div className="col-md-6 text-center text-md-left">
                        <h1 className="mb-4 mb-md-0 text-white">Renewable Energy</h1>
                     </div>
                        <div className="col-md-6 text-center text-md-right">
                            <div id="Photovoltaïque" className="d-inline-flex align-items-center">
                                <Link className="btn text-white" to="/">Home</Link>
                                <FontAwesomeIcon className="fas fa-angle-right text-white" icon={faAngleRight} />
                              
                                <Link className="btn text-white disabled" to="/energie-renouvable">Renewable Energy</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

            <div className="container service"  >
             <div className="row" >
                 <h1 style={{color:'red'}}>PHOTOVOLTAIC</h1>
                 <div className="col-md-12 Pandingh2">
                    <p className="p-ses" style={{textAlign:"center"}} >
                    Thanks to its expertise, MPEMI offers tailor-made, turnkey photovoltaic solutions, adapted to the needs of individuals and professionals (industrial, tertiary and agricultural).

                    MPEMI is currently involved in solar farms for energy-intensive companies and offers complete solutions: from the study phase, through to construction and operation                    </p>
                 </div>
                 <div className="row">
                    <div className="col-lg-6 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="100" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={PhotoPlant} alt="QSl" />
                    <div className="service-overlay">
                    <p>
                    solar PV power plant is the first choice for meeting rapidly growing demands; as it can be installed relatively quickly, say in 6-12 months, compared to that of the fossil-fuel-based plants that may require more than 4-5 years.
                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>MV Photovoltaic Plant</h3>
                    <Model
                    title ="MV Photovoltaic Plant"
                    body="solar PV power plant is the first choice for meeting rapidly growing demands; as it can be installed relatively quickly, say in 6-12 months, compared to that of the fossil-fuel-based plants that may require more than 4-5 years."
                    />
                    </div>
                    </div>
                    </div>
                    <div className="col-lg-6 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="200">
                    <div className="service-item">
                    <div className="service-img">
                    <img src={offgridsolar} alt="qsd"/>
                    <div className="service-overlay">
                    <p>
                    The quality of the equipment and in particular the adequacy between the batteries, the charge regulator and the inverter charger will allow you to ensure the site's electricity supply and peace of mind.
                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>Off-grid systems</h3>
                    <Model
                    title ="Off-grid systems"
                    body="The quality of the equipment and in particular the adequacy between the batteries, the charge regulator and the inverter charger will allow you to ensure the site's electricity supply and peace of mind."
                    />
                    </div>
                    </div>
                    </div>
                    <div className="col-lg-6 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="300" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={Pumping} alt="no" />
                    <div className="service-overlay">
                    <p >
                    Solar pumping is an efficient, reliable and clean alternative to conventional motor pumps and pumps powered by generator sets.

                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3> Photovoltaic Pumping</h3>
                    <Model
                    title ="Photovoltaic Pumping"
                    body="Solar pumping is an efficient, reliable and clean alternative to conventional motor pumps and pumps powered by generator sets."
                    />  
                     </div>
                    </div>
                    </div>
                   
                    <div className="col-lg-6 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="100" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={ongirdsystem} alt="rf" />
                    <div className="service-overlay">
                    <p>
                    A grid-connected photovoltaic system is connected to the public electricity distribution grid.
                    Photovoltaic installations are generally of high reliability, little subject to wear, they require little maintenance.
                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>On-grid systems	</h3>
                    <Model
                    title ="On-grid systems"
                    body="A grid-connected photovoltaic system is connected to the public electricity distribution grid.
                    Photovoltaic installations are generally of high reliability, little subject to wear, they require little maintenance."
                    /> 
                     </div>
                    </div>
                    </div>
                    
             </div>
            </div>



      </div>


      <div className="container">
          <div className="row " >
              <div className="col">
                 <h3 className='h3-ses'>
             CONTACT For a preliminary study of your project
               
              </h3>
              <p className='p-ses'>
              Our experts can help you make your photovoltaic project a reality, or simply study your needs, your expectations and answer your questions. Send us your message and we will get back to you as soon as possible.
              </p> 
              </div>
              <div  className="col roww">
              <a id="efficacité-énergétique" class="btn" href="/contact">CONTACT US</a>
              </div>
              

          </div>
      </div>


      <div className="container service" >
             <div className="row">
             <h1 style={{color:'red'}}>Energy Efficiency</h1>

                 <div className="col-md-12 Pandingh2">
                    <p className="p-ses" style={{textAlign:"center"}} >
                    
                            MPEMI activities often include lighting, water, heating, ventilation, cooling, building envelope, smart meters  and controls. We first implement efficiency gains in order to establish a strong baseline for renewable energy generation needs.
                    </p>
                 </div>
                 <div className="row" >
                    <div className="col-lg-6 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="100" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={audit} alt="QSl" />
                    <div className="service-overlay">
                    <p>
                    (level 1, 2 & 3) and emission reduction (commercial and industrial) including benchmarking and monitoring.                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3> Energy AUDIT</h3>
                    <Model
                    title ="Energy AUDIT"
                    body="(level 1, 2 & 3) and emission reduction (commercial and industrial) including benchmarking and monitoring. "
                    />  
                     </div>
                    </div>
                    </div>
                    <div className="col-lg-6 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="200">
                    <div className="service-item">
                    <div className="service-img">
                    <img src={mesure} alt="qsd"/>
                    <div className="service-overlay">
                    <p>
                    Our staff are trained in world's best practice M&V, using the International Performance Measurement and Verification Protocol (IPMVP)  .                  </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>Measurement and Verification M&V</h3>
                    <Model
                    title ="Measurement and Verification M&V"
                    body="Our staff are trained in world's best practice M&V, using the International Performance Measurement and Verification Protocol (IPMVP)  . "
                    />
                    </div>
                    </div>
                    </div>
                    <div className="col-lg-6 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="300" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={GTB} alt="no" />
                    <div className="service-overlay">
                    <p>
                    Unique solutions for integrated and centralized control of your installations: HVAC, Lighting, Blinds, Access control, Energy management.<br/>
                    Automation solutions for energy performance in buildings.
                     </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>Centralized technical management  GTC / GTB </h3>
                    <Model
                    title ="Centralized technical management  GTC / GTB "
                    body="Unique solutions for integrated and centralized control of your installations: HVAC, Lighting, Blinds, Access control, Energy management.<br/>
                    Automation solutions for energy performance in buildings."
                    />  
                     </div>
                    </div>
                    </div>
                   
                    <div className="col-lg-6 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="100" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={iso} alt="rf" />
                    <div className="service-overlay">
                    <p>
                    Our experts assist you in setting up the management system and thus meet the requirements of the ISO 50001.                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>Energy management</h3>
                    <Model
                    title ="Energy management"
                    body=" Our experts assist you in setting up the management system and thus meet the requirements of the ISO 50001. "
                    />        </div>
                    </div>
                    </div>
                    
             </div>
            </div>



      </div>


      <div className="container">
          <div className="row " >
              <div className="col">
                 <h3 className='h3-ses'>
             CONTACT For a preliminary study of your project
               
              </h3>
              <p className='p-ses'>
              Our experts can help you make your Energy Efficiency project a reality, or simply study your needs, your expectations and answer your questions. Send us your message and we will get back to you as soon as possible.
              </p> 
              </div>
              <div className="col roww">
              <a id="Thermal-solar-energy" class="btn" href="/contact">CONTACT US</a>
              </div>
              

          </div>
      </div>






      
      <div className="container service">
             <div className="row">
             <h1 style={{color:'red'}}>OTHER RENEWABLE ENERGY SOLUTIONS</h1>

                 <div className="col-md-12 Pandingh2">
                    <p className="p-ses" style={{textAlign:"center"}} >
                      Our Experts develop on command, specific renewable energy systems from dezign and sizing until installation and commissioning 
                     </p>
                 </div>
                 <div className="row" >
                    <div className="col-lg-6 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="100" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={IndividualSolar} alt="QSl" />
                    <div className="service-overlay">
                    <p>
                    Solar water heater cuts down on greenhouse gas emissions in the atmosphere, and also helps you save money long-term by reducing gas and electricity bills.
                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>Collectif & Individual Solar water heater</h3>
                    <Model
                    title ="Collectif & Individual Solar water heater"
                    body="Solar water heater cuts down on greenhouse gas emissions in the atmosphere, and also helps you save money long-term by reducing gas and electricity bills."
                    />  
                     </div>
                    </div>
                    </div>
                    <div className="col-lg-6 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="200">
                    <div className="service-item">
                    <div className="service-img">
                    <img src={Biogaz} alt="qsd"/>
                    <div className="service-overlay">
                    <p>
                    <ul>
                        <li style={{textAlign:"left"}}>Biomethane Production</li>
                        

                        <li style={{textAlign:"left"}}>waste treatment and energy recovery</li>

                        <li style={{textAlign:"left"}}>Cogeneration</li>

                    </ul>
                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>Biomass & CHP</h3>
                    <Model
                    title ="Biomass & CHP"
                    body={["Biomethane Production",<br/>,"waste treatment and energy recovery",<br/>,"Cogeneration"]}
                    />
                    </div>
                    </div>
                    </div>
                    <div className="col-lg-6 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="300" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={EnergyStorage} alt="no" />
                    <div className="service-overlay">
                    <p>
                      Hybrid energy storage solutions:
                      <ul>
                      <br/><li style={{textAlign:"left"}}>
                         Supercapacitors
                          </li>
                          <li style={{textAlign:"left"}}>
                          Fuel cells
                          </li>
                          <li style={{textAlign:"left"}}>
                          Batteries
                          </li>
                          <li style={{textAlign:"left"}}>
                              Smart grids 
                          </li>
                      </ul> 
                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>Energy Storage</h3>
                    <Model
                    title ="Energy Storage"
                    body={["Hybrid energy storage solutions:",<br/>," Supercapacitors",<br/>,"Fuel cells",<br/>," Batteries",<br/>,"Smart grids "]}
                    />  
                     </div>
                    </div>
                    </div>
                   
                    <div className="col-lg-6 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="100" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={WIND} alt="rf" />
                    <div className="service-overlay">
                    <p>
                        Small wind turbines installation & maintenance .
                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>Wind energy	</h3>
                    <Model
                    title ="Wind energy"
                    body="Small wind turbines installation & maintenance ."
                    />        </div>
                    </div>
                    </div>
                    
             </div>
            </div>



      </div>


      <div className="container">
          <div className="row " >
              <div className="col">
                 <h3 className='h3-ses'>
             CONTACT For a preliminary study of your project
               
              </h3>
              <p className='p-ses'>
              Our experts can help you make your R.E project a reality, or simply study your needs, your expectations and answer your questions. Send us your message and we will get back to you as soon as possible.
              </p> 
              </div>
              <div className="col roww">
              <a class="btn" href="/contact">CONTACT US</a>
              </div>
              

          </div>
      </div>
     


      

     </div>
    );
}
export default EnergieRenv;



